export const INSTITUTION_OPTION_TYPES = {
    SET_INSTITUTION_OPTION_TYPES: 'SET_INSTITUTION_OPTION_TYPES'
}